import styled, { css } from 'styled-components'
import { ChevronIcon } from '@sainsburys-tech/bolt-icons'
import { GridWrapper } from '@sainsburys-tech/grid'
import { createCSSObject, remCalculator, colorToLunaToken } from '../../../helpers/theming/utilities'
import { TextWrapper } from '../../../helpers/StyledWrappers.styles.js'
import { themeContract } from './C006.theme.contract.js'
import { C006StyledHeading, C006StyledContainer, C006StyledLink } from './types'

const backgroundStyles = css<C006StyledContainer>`
  ${(props) =>
    props.backgroundColor &&
    css`
      background-color: ${colorToLunaToken(props.backgroundColor, props.theme)};
      padding: ${props.theme.size.spacing.lg} ${props.theme.size.spacing.xl};
    `}
`

const linkColor = (props) => colorToLunaToken(props.linkColor, props.theme) || props.theme.color.palette['brand-1']

export const Container = styled(GridWrapper)`
  ${backgroundStyles}
  ${(props) =>
    props.hasMargin &&
    css`
      margin-top: ${props.theme.size.spacing.lg};

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        margin-top: ${props.theme.size.spacing.xl};
      }
    `}
    margin-bottom: ${(props) => props.theme.size.spacing.lg};
`

export const Heading = styled.h2<C006StyledHeading>`
  ${TextWrapper}
  ${(props) =>
    css`
      color: ${colorToLunaToken(props.textColor, props.theme) ||
      props.theme.color.palette[themeContract[props.theme.channel].heading.color]};

      && {
        ${props.theme.channel !== 'sainsburys' &&
        createCSSObject(props.theme.font.stack[themeContract[props.theme.channel].heading.display])}
        margin-bottom: ${props.theme.size.spacing.sm};
      }
    `}
`

export const LinkContainer = styled.div<C006StyledLink>`
  ${(props) =>
    css`
      display: flex;
      justify-content: flex-start;

      && {
        a {
          color: ${linkColor(props)};
        }
      }

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        margin-top: ${props.theme.size.spacing.md};
        justify-content: flex-end;
      }
    `}
`

export const Chevron = styled(ChevronIcon)`
  stroke: ${(props) => linkColor(props)};
  margin-left: ${(props) => remCalculator(props.theme.size.spacing.sm)};
  position: relative;
  top: ${(props) => remCalculator(props.theme.size.spacing.sm)};
`
